import { CategoryQuestions } from '../types';

export const fitnessQuestions: CategoryQuestions = {
  title: 'Personalize Your Fitness Motivation Session',
  questions: {
    preferredStyle: {
      label: 'What type of fitness motivation works best for you?',
      type: 'radio',
      options: ['High-intensity pump up', 'Steady encouraging support', 'Mental strength focus', 'Body positivity emphasis']
    },
    primaryGoal: {
      label: 'What is your primary fitness goal?',
      type: 'radio',
      options: ['Weight loss and fat burning', 'Strength building and muscle gain', 'Endurance and cardio fitness', 'Mental strength and confidence', 'Overall wellness and health']
    },
    workoutType: {
      label: 'What type of workout are you doing or preparing for?',
      type: 'radio',
      options: ['Cardio (running, cycling, etc.)', 'Strength training (weights, resistance)', 'HIIT or circuit training', 'Yoga or flexibility work', 'Mixed or varied workout']
    },
    fitnessLevel: {
      label: 'What is your current fitness level?',
      type: 'radio',
      options: ['Beginner - just starting out', 'Intermediate - regular exerciser', 'Advanced - experienced athlete', 'Returning after break']
    },
    motivationStyle: {
      label: 'What kind of coaching style motivates you?',
      type: 'radio',
      options: ['Gentle encouragement and support', 'Challenging push to go harder', 'Focus on form and technique', 'Mind-body connection emphasis']
    },
    bodyFocus: {
      label: 'Which areas are you focusing on today?',
      type: 'radio',
      options: ['Full body workout', 'Upper body strength', 'Lower body power', 'Core and stability', 'Cardiovascular endurance']
    },
    sessionTiming: {
      label: 'When will you use this session?',
      type: 'radio',
      options: ['Pre-workout pump up', 'During workout motivation', 'Post-workout recovery', 'General fitness inspiration']
    },
    mentalChallenges: {
      label: 'What mental barriers do you want to overcome?',
      type: 'textarea',
      placeholder: 'e.g., self-doubt, lack of motivation, consistency issues, body image concerns...'
    },
    specificFocus: {
      label: 'Any specific fitness goals or challenges for today?',
      type: 'textarea',
      placeholder: 'Optional - e.g., first day back, trying new exercise, pushing through plateau...'
    },
    specialOccasions: {
      label: 'Are you celebrating any fitness milestones today?',
      type: 'textarea',
      placeholder: 'e.g., weight loss goal reached, new personal record, fitness challenge completion...'
    },
    personalizationPreferences: {
      label: 'What would help make this session feel more personalized for you?',
      type: 'textarea',
      placeholder: 'e.g., use my name, reference my specific goals, acknowledge my progress, mention my challenges...'
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for you?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    }
  },
  groupTitle: 'Personalize Your Group Fitness Motivation Session',
  groupQuestions: {
    groupType: {
      label: 'What type of fitness group are you motivating?',
      type: 'radio',
      options: ['Workout class/gym group', 'Sports team', 'Fitness challenge participants', 'Running/cycling club', 'Weight loss support group', 'Corporate wellness group']
    },
    collectiveGoal: {
      label: 'What fitness goal is your group working toward?',
      type: 'textarea',
      placeholder: 'Describe the shared fitness challenge, event, or goal your group is pursuing...'
    },
    groupDynamics: {
      label: 'What motivational approach works best for your group?',
      type: 'radio',
      options: ['High-energy team pumping', 'Supportive peer encouragement', 'Individual recognition within group', 'Shared accountability and commitment']
    },
    workoutContext: {
      label: 'What type of group fitness activity?',
      type: 'radio',
      options: ['Group fitness class', 'Team training session', 'Outdoor group workout', 'Virtual fitness meetup', 'Fitness challenge kickoff']
    },
    groupFitnessLevel: {
      label: 'What is the general fitness level of your group?',
      type: 'radio',
      options: ['Mixed levels (beginners to advanced)', 'Mostly beginners', 'Intermediate level', 'Advanced/athletic group']
    },
    groupChallenges: {
      label: 'What challenges is your fitness group facing?',
      type: 'textarea',
      placeholder: 'Optional - e.g., motivation dips, consistency issues, intimidation, plateau...'
    },
    leadershipStyle: {
      label: 'How should the motivation be delivered to the group?',
      type: 'radio',
      options: ['Energetic pump-up rally', 'Inclusive team building', 'Individual empowerment focus', 'Goal-oriented planning session']
    },
    specialOccasions: {
      label: 'Are you celebrating any group fitness achievements today?',
      type: 'textarea',
      placeholder: 'e.g., member milestones, group challenge completion, fitness event participation...'
    },
    groupPersonalizationPreferences: {
      label: 'What would help make this session feel more personalized for your team?',
      type: 'textarea',
      placeholder: 'e.g., reference our team goals, acknowledge our work environment, celebrate recent wins, address specific challenges...'
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for your group?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    }
  },
  practitionerGroupTitle: 'Personalize Your Clients\' Group Fitness Motivation Session',
  practitionerGroupQuestions: {
    groupType: {
      label: 'What type of fitness group are you motivating?',
      type: 'radio',
      options: ['Workout class/gym group', 'Sports team', 'Fitness challenge participants', 'Running/cycling club', 'Weight loss support group', 'Corporate wellness group']
    },
    collectiveGoal: {
      label: 'What fitness goal are your clients working toward together?',
      type: 'textarea',
      placeholder: 'Describe the shared fitness challenge, event, or goal your clients are pursuing...'
    },
    groupDynamics: {
      label: 'What motivational approach works best for your clients?',
      type: 'radio',
      options: ['High-energy team pumping', 'Supportive peer encouragement', 'Individual recognition within group', 'Shared accountability and commitment']
    },
    workoutContext: {
      label: 'What type of group fitness activity?',
      type: 'radio',
      options: ['Group fitness class', 'Team training session', 'Outdoor group workout', 'Virtual fitness meetup', 'Fitness challenge kickoff']
    },
    groupFitnessLevel: {
      label: 'What is the general fitness level of your clients?',
      type: 'radio',
      options: ['Mixed levels (beginners to advanced)', 'Mostly beginners', 'Intermediate level', 'Advanced/athletic group']
    },
    groupChallenges: {
      label: 'What challenges are your clients facing as a group?',
      type: 'textarea',
      placeholder: 'Optional - e.g., motivation dips, consistency issues, intimidation, plateau...'
    },
    leadershipStyle: {
      label: 'How should the motivation be delivered to your clients?',
      type: 'radio',
      options: ['Energetic pump-up rally', 'Inclusive team building', 'Individual empowerment focus', 'Goal-oriented planning session']
    },
    specialOccasions: {
      label: 'Are your clients celebrating any group fitness achievements today?',
      type: 'textarea',
      placeholder: 'e.g., member milestones, group challenge completion, fitness event participation...'
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for your clients?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    }
  },
  practitionerTitle: 'Personalize Your Client\'s Fitness Motivation Session',
  practitionerQuestions: {
    preferredStyle: {
      label: 'What type of fitness motivation works best for your client?',
      type: 'radio',
      options: ['High-intensity pump up', 'Steady encouraging support', 'Mental strength focus', 'Body positivity emphasis']
    },
    primaryGoal: {
      label: 'What is your client\'s primary fitness goal?',
      type: 'radio',
      options: ['Weight loss and fat burning', 'Strength building and muscle gain', 'Endurance and cardio fitness', 'Mental strength and confidence', 'Overall wellness and health']
    },
    workoutType: {
      label: 'What type of workout is your client doing or preparing for?',
      type: 'radio',
      options: ['Cardio (running, cycling, etc.)', 'Strength training (weights, resistance)', 'HIIT or circuit training', 'Yoga or flexibility work', 'Mixed or varied workout']
    },
    fitnessLevel: {
      label: 'What is your client\'s current fitness level?',
      type: 'radio',
      options: ['Beginner - just starting out', 'Intermediate - regular exerciser', 'Advanced - experienced athlete', 'Returning after break']
    },
    motivationStyle: {
      label: 'What kind of coaching style motivates your client?',
      type: 'radio',
      options: ['Gentle encouragement and support', 'Challenging push to go harder', 'Focus on form and technique', 'Mind-body connection emphasis']
    },
    bodyFocus: {
      label: 'Which areas is your client focusing on today?',
      type: 'radio',
      options: ['Full body workout', 'Upper body strength', 'Lower body power', 'Core and stability', 'Cardiovascular endurance']
    },
    sessionTiming: {
      label: 'When will your client use this session?',
      type: 'radio',
      options: ['Pre-workout pump up', 'During workout motivation', 'Post-workout recovery', 'General fitness inspiration']
    },
    mentalChallenges: {
      label: 'What mental barriers does your client want to overcome?',
      type: 'textarea',
      placeholder: 'e.g., self-doubt, lack of motivation, consistency issues, body image concerns...'
    },
    specificFocus: {
      label: 'Any specific fitness goals or challenges for your client today?',
      type: 'textarea',
      placeholder: 'Optional - e.g., first day back, trying new exercise, pushing through plateau...'
    },
    specialOccasions: {
      label: 'Is your client celebrating any fitness milestones today?',
      type: 'textarea',
      placeholder: 'e.g., weight loss goal reached, new personal record, fitness challenge completion...'
    },
    personalizationPreferences: {
      label: 'What would help make this session feel more personalized for your client?',
      type: 'textarea',
      placeholder: 'e.g., use their name, reference their specific goals, acknowledge their progress, mention their challenges...'
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for your client?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    }
  },
  giftTitle: 'Personalize Fitness Motivation for Your Loved One',
  giftQuestions: {
    preferredStyle: {
      label: 'What type of fitness motivation works best for them?',
      type: 'radio',
      options: ['High-intensity pump up', 'Steady encouraging support', 'Mental strength focus', 'Body positivity emphasis']
    },
    primaryGoal: {
      label: 'What is their primary fitness goal?',
      type: 'radio',
      options: ['Weight loss and fat burning', 'Strength building and muscle gain', 'Endurance and cardio fitness', 'Mental strength and confidence', 'Overall wellness and health']
    },
    workoutType: {
      label: 'What type of workout are they doing or preparing for?',
      type: 'radio',
      options: ['Cardio (running, cycling, etc.)', 'Strength training (weights, resistance)', 'HIIT or circuit training', 'Yoga or flexibility work', 'Mixed or varied workout']
    },
    fitnessLevel: {
      label: 'What is their current fitness level?',
      type: 'radio',
      options: ['Beginner - just starting out', 'Intermediate - regular exerciser', 'Advanced - experienced athlete', 'Returning after break']
    },
    mentalChallenges: {
      label: 'What mental barriers do they want to overcome?',
      type: 'textarea',
      placeholder: 'e.g., self-doubt, lack of motivation, consistency issues, body image concerns...'
    },
    additionalNotes: {
      label: 'Anything else the AI should know to create a perfect session for them?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    },
  }
};
